import { render } from "./customer_status.vue?vue&type=template&id=d0fe98a6"
import script from "./customer_status.vue?vue&type=script&lang=js"
export * from "./customer_status.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__